import { MyOrdersIcon } from "../../../../assets"
import styles from "./style.module.css"

export const MyOrdersButton = () =>{

    return(

        <div className={styles.container}>

            <MyOrdersIcon className={styles.icon}/>
            
            My Orders
        </div>

    )

}